<template>
  <div>
    <div :class="{ wrap: collapse }" @click="closeNav"></div>
    <div class="sidebar-container" :class="{ 'sidebar-open': collapse }">
      <el-row class="tac h-100">
        <el-col class="w-100" style="display:flex;flex-direction:column">
          <!-- <img src="" alt="" class="logo" /> -->
          <p class="logo" style="font-size:20px;color:white">
            鑫富發
          </p>
          <el-menu
            style="width:220px"
            unique-opened
            :default-active="$route.name"
            class="el-menu-vertical-demo"
            @close="handleClose"
            background-color="#304156"
            text-color="#fff"
            active-text-color="#ffd04b"
            :router="false"
          >
            <el-submenu
              :index="wrap[key]"
              v-for="(wrap, key) in menuList"
              :key="key"
            >
              <template slot="title">
                <i :class="wrap.icon"></i>
                <span>{{ wrap[key] }}</span>
              </template>
              <el-menu-item
                v-show="subKey != 'settings.personal'"
                @click="goRouter(subKey)"
                :index="subKey"
                v-for="(sub, subKey) in wrap.sub"
                :key="subKey"
                >{{ sub }}
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notifyShow: ""
    };
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
    selfInfo() {
      return this.$store.state.selfInfo;
    },
    menuList() {
      return this.$store.state.menuList;
    },
    tableData() {
      return this.$store.state.notifyList;
    },
    notifyInfo() {
      return this.$store.state.notifyInfo;
    },
    rooms() {
      return this.$store.state.message.rooms;
    }
  },
  watch: {
    $route() {
      this.$store.dispatch("navHandler", false);
    }
  },
  methods: {
    returnUnread() {
      return (
        this.rooms.reduce((a, b) => {
          return a + (Number(b.unreadNum) || 0);
        }, 0) || ""
      );
    },
    goRouter(route) {
      if (route != "admin.log") {
        this.$router.push(route);
      } else {
        window.open(process.env.VUE_APP_L_LINK);
      }
    },
    openMsg() {
      this.$store.dispatch("message/showRoomHandler", true);
    },
    closeNav() {
      this.$store.dispatch("navHandler", false);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    returnRoute() {}
  },
  created() {
    this.$store.dispatch("getMenu");
  }
};
</script>

<style lang="scss" scoped>
.tac::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.tac {
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
}
.tac {
  background-color: #304156;
  height: 100%;
  overflow: scroll;
  //   padding: 10px 20px;
}
.el-menu {
  border: none !important;
  //   padding: 0 20px;
  width: 220px;
}
.el-menu-item {
  width: 220px;
}
.sidebar-container {
  transition: 0.5s ease-in-out !important;
}
@media (max-width: 992px) {
  .sidebar-container {
    margin-left: -220px;
  }
  .sidebar-open {
    margin-left: 0;
    transition: 0.5s ease-in-out;
  }
  .wrap {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background-color: rgba(black, 0.6);
  }
}
span {
  margin-left: 15px;
}
.logo {
  padding: 10px 0px;
  text-align: center;
  width: 100%;
  // padding: 10px;
  // width: 100px;
  // padding-left: 20px;
}
</style>
